// Persistencia por sesión del botón de códigos de árbol: sobrevive a recargas (F5)
// y se reinicia al cerrar la pestaña. Sin preferencia guardada, queda deshabilitado.
export const TREE_CODE_LABELS_STORAGE_KEY = 'ArbolEc_treeCodeLabelsEnabled'

// Lee la preferencia de la sesión. Retorna false si no existe o el storage falla.
export const loadTreeCodeLabelsEnabled = () => {
  try {
    return window.sessionStorage.getItem(TREE_CODE_LABELS_STORAGE_KEY) === 'true'
  } catch {
    return false
  }
}

// Guarda la preferencia para la sesión actual.
export const saveTreeCodeLabelsEnabled = enabled => {
  try {
    window.sessionStorage.setItem(TREE_CODE_LABELS_STORAGE_KEY, String(Boolean(enabled)))
  } catch (error) {
    console.warn('No se pudo guardar la preferencia de códigos de árbol:', error)
  }
}
